<template>
    <header class="navigation">
        <nav class="navbar navbar-expand-lg" id="navbar">
            <div class="container-warp">
                <a class="navbar-brand" style="color: #fff" @click="jumpHome()">
                  <img
                    src="../../assets/images/newImgs/logo.png"
                    alt=""
                    class="img-fluid"
                  />
<!--                    {{ $t("l.header.title") }}-->
                  <span></span>
                </a>

                <button
                    class="navbar-toggler collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarsExample09"
                    aria-controls="navbarsExample09"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="fa fa-bars"></span>
                </button>

                <div
                    class="collapse navbar-collapse text-center"
                    id="navbarsExample09"
                >
                    <ul class="navbar-nav">
                        <li class="nav-item active">
                            <a :class="{'nav-link': true, 'nav-link-blue': this._props && Number(this._props.type) === 1}" @click="jumpHome()"
                                >{{ $t("l.header.homeLink") }}
                                <span class="sr-only">(current)</span></a
                            >
                        </li>
                        <li class="nav-item dropdown">
                            <a
                                :class="{'nav-link': true, 'nav-link-blue': this._props && Number(this._props.type) === 2}"
                                @click="jumpAssistant()"
                                >{{ $t("l.header.productLink") }}</a
                            >
<!--                            <ul-->
<!--                                class="dropdown-menu"-->
<!--                                aria-labelledby="dropdown03"-->
<!--                            >-->
<!--                                <li>-->
<!--                                    &lt;!&ndash; <span  class="nav-link" @click="jumpAssistant()">智能交易</span> &ndash;&gt;-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpAssistant()"-->
<!--                                        >{{-->
<!--                                            $t("l.header.smartExecutionLink")-->
<!--                                        }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    &lt;!&ndash; <span  class="nav-link" @click="jumpInvestment()">智能投研</span> &ndash;&gt;-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpInvestment()"-->
<!--                                        >{{-->
<!--                                            $t("l.header.smartAnalyticsLink")-->
<!--                                        }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    &lt;!&ndash; <span  class="nav-link" @click="jumpInvestment()">产业链风控</span> &ndash;&gt;-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpIndustrialChain()"-->
<!--                                        >{{-->
<!--                                            $t("l.header.industrialChainLink")-->
<!--                                        }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    &lt;!&ndash; <span  class="nav-link" @click="jumpInvestment()">智能投研</span> &ndash;&gt;-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpEduAndResearch()"-->
<!--                                        >{{ $t("l.header.edu") }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    &lt;!&ndash; <span  class="nav-link" @click="jumpInvestment()">交易监察自查</span> &ndash;&gt;-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpTransaction()"-->
<!--                                        >{{ $t("l.header.transactionMonitoring") }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                            </ul>-->
                        </li>
                      <li class="nav-item">
                        <a
                          :class="{'nav-link': true, 'nav-link-blue': this._props && Number(this._props.type) === 3}"
                          @click="jumpBusiness()"
                        >{{ $t("l.header.business") }}</a
                        >
                      </li>
                         <!-- <li class="nav-item dropdown">
                            <a
                                class="nav-link dropdown-toggle"
                                href="#"
                                id="dropdown03"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                >校企联培</a
                            >
                            <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdown03"
                            >
                            </ul>
                        </li> -->
                        <li class="nav-item dropdown">
                            <!-- <a class="nav-link" @click="jumpAbout()">关于我们</a> -->
                            <a
                              :class="{'nav-link': true, 'nav-link-blue': this._props && Number(this._props.type) === 4}"
                                class="nav-link dropdown-toggle"
                                @click="jumpAbout()"
                                >{{ $t("l.header.aboutLink") }}</a
                            >
<!--                            <ul-->
<!--                                class="dropdown-menu"-->
<!--                                aria-labelledby="dropdown04"-->
<!--                            >-->
<!--                                <li>-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpAbout()"-->
<!--                                        >{{ $t("l.header.teamLink") }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpHonor()"-->
<!--                                        >{{ $t("l.header.awardsLink") }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a-->
<!--                                        class="dropdown-item"-->
<!--                                        @click="jumpBusiness()"-->
<!--                                        >{{ $t("l.header.businessCase") }}</a-->
<!--                                    >-->
<!--                                </li>-->
<!--                            </ul>-->
                        </li>
                        <li class="nav-item">
                            <a
                               :class="{'nav-link': true, 'nav-link-blue': this._props && Number(this._props.type) === 5}"
                               @click="jumpContact()">
                              {{$t("l.header.contactLink")
                            }}</a>
                        </li>
                        <li class="nav-item nav-language">
                            <a
                                class="nav-link btn-language btn-round-full"
                                @click="changeLanguage()"
                            >
                                {{ $t("l.language") }}
                            </a>
                        </li>
                    </ul>

<!--                    <form-->
<!--                        class="form-lg-inline my-2 my-md-0 ml-lg-4 text-center"-->
<!--                    >-->
<!--                        <a-->
<!--                            href="http://trade.datafareast.cn/"-->
<!--                            target="_Self"-->
<!--                            class="btn btn-solid-border btn-round-full"-->
<!--                            >{{ $t("l.header.loginLink") }}</a-->
<!--                        >-->
<!--                    </form>-->
                </div>
            </div>
        </nav>
    </header>
</template>
<script>
export default {
    name: "",
    props: ['type'],
    data() {
        return {};
    },
    mounted() {
      console.log('header', this, this._props.type, typeof this._props.type)
    },
    methods: {
      // 切换语言
        changeLanguage() {
            console.log('切换语言',this.$i18n.locale);
            const lang = this.$i18n.locale === "zh-CN" ? "en" : "zh-CN";
            this.$i18n.locale = lang;
            localStorage.setItem("languageSet", lang);
        },
        // 首页
        jumpHome() {
            this.$router.push("/");
        },
        // 关于我们
        jumpAbout() {
            this.$router.push("/about");
        },
        // 公司荣誉
        jumpHonor() {
            this.$router.push("/aboutHonor");
        },
        // 团队商业案例
        jumpBusiness() {
            this.$router.push("/businessCase");
        },
        // 公司历程
        jumpHistory() {
            this.$router.push("/aboutHistory");
        },
        // 联系我们
        jumpContact() {
            this.$router.push("/contact");
        },
        // 智能交易
        jumpAssistant() {
            this.$router.push("/smartExecution");
        },
        // 智能投研
        jumpInvestment() {
            this.$router.push("/smartAnalytics");
        },
        // 产业链
        jumpIndustrialChain() {
            this.$router.push("/industrialChain");
        },
        // 教育科研
        jumpEduAndResearch() {
            this.$router.push("/eduAndResearch");
        },
        // 交易监查
        jumpTransaction() {
            this.$router.push("/transactionSupervision");
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
    text-align: left;
}
.nav-language{
  margin-left: auto !important;
  a{

    font-size: 12px !important;
  }
}
.nav-link-blue{
  color:rgba(64, 169, 255, 1) !important;
}
.container-warp{
  display: flex;
  flex-flow: row nowrap;
  width: 1200px;
  margin: 0 auto;
}
.navbar-nav{
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue